// extracted by mini-css-extract-plugin
export default {"container":"TextRotator_container__jYkeO","mask":"TextRotator_mask__GC4we"};